import {saraTheme} from "../../theme/saraTheme";

const yup = require("yup");
export const registrationMap = [
    {
        id: 'registrazioneUtente',
        name: "registrazioneUtente",
        title: 'registrazioneTitolo',
        subtitle: "",
        fields: [
            {
                id: 'nome',
                name: 'nome',
                label: 'nome',
                type: 'text',
                required: true,
                validations: ['string','required'],
                precompiled: true,
                params: {
                    required: "Questo campo è obbligatorio"
                }
            },
            {
                id: 'cognome',
                name: 'cognome',
                label: 'cognome',
                type: 'text',
                required: true,
                validations: ['string','required'],
                precompiled: true,
                params: {
                    required: "Questo campo è obbligatorio"
                }
            },
            {
                id: 'email',
                name: 'email',
                label: 'Email',
                type: 'email',
                required: true,
                validations: ['string','required'],
                precompiled: true,
                params: {
                    required: "Questo campo è obbligatorio"
                }
            },
            {
                id: 'codiceAgenzia',
                name: 'codiceAgenzia',
                label: 'Codice Agenzia',
                type: 'text',
                required: false,
                validations: ['string','when'],
                precompiled: true,
                params: {
                    when: [
                        ['categoria'], {
                            is: (categoria) => categoria === 'AGENTE',
                            then: (schema) => schema.required("Questo campo è obbligatorio")
                        }
                    ]
                },
                conditions: {
                    type: "or",
                    predicates: [
                        {
                            id: 'categoria',
                            value: 'AGENTE'
                        }
                    ]
                }
            },
            {
                id: 'cellulare',
                name: 'cellulare',
                label: 'Telefono Aziendale',
                type: 'text',
                required: true,
                validations: ['string','required'],
                precompiled: false,
                params: {
                    required: "Questo campo è obbligatorio"
                }
            },
            {
                id: 'intolleranze',
                name: 'intolleranze',
                label: 'intolleranze',
                type: 'textBlock',
                required: false,
                validations: [],
                precompiled: false,
                cols:{
                    xs:12,
                }
            },
            {
                id: 'intolleranzeNote',
                name: 'intolleranzeNote',
                label: 'intolleranzeNote',
                type: 'note',
                fontSize: '12px',
                required: false,
                validations: [],
                precompiled: false,
                cols:{
                    xs:12,
                }
            },
        ]
    },
    {
        id: 'partecipazioneRoma',
        name: "partecipazioneRoma",
        title: 'Roma',
        subtitle: "",
        fields: [
            {
                id: 'agendaRoma',
                name: "agendaRoma",
                type: 'agenda',
                conditions: {
                    type: "or",
                    predicates: [
                        {
                            id: 'roma',
                            value: 'si'
                        }
                    ]
                },
                cols:{
                    xs:12,
                    md:12
                }
            },
            {
                id: 'romaPartecipazioneConferma',
                name: 'romaPartecipazioneConferma',
                label: "confermaPartecipazione",
                type: 'radiogroup',
                validations: ["string", 'when'],
                required: false,
                precompiled: false,
                values: [
                    {
                        value: "si",
                        label: "Si"
                    },
                    {
                        value: "no",
                        label: "No"
                    }
                ],
                params: {
                    when: [
                        ['roma'], {
                            is: (roma) => roma === 'si',
                            then: (schema) => schema.required("Questo campo è obbligatorio")
                        }
                    ]
                },
                conditions: {
                    type: "or",
                    predicates: [
                        {
                            id: 'roma',
                            value: 'si'
                        }
                    ]
                },
                cols: {
                    xs: 12,
                    md: 12
                }
            },
            /*{
                id: 'navettaRomaConferma',
                name: 'navettaRomaConferma',
                label: "navettaRomaConferma",
                type: 'radiogroup',
                validations: ["string", 'when'],
                row: false,
                precompiled: false,
                values: [
                    {
                        value: "no",
                        label: "No, non usufruirò del servizio navetta."
                    },
                    {
                        value: "navettaArSedeViaPo",
                        label: <>Usufruirò del servizio navetta andata e ritorno da <b>Sede Sara Via Po</b> con partenza ore <b>11:00</b></>
                    },
                    {
                        value: "navettaArStazioneTermini",
                        label: <>Usufruirò del servizio navetta andata e ritorno da <b>Stazione Termini</b> con partenza ore <b>11:00</b></>
                    },
                    {
                        value: "navettaArAeroportoFiumicino1",
                        label: <>Usufruirò del servizio navetta andata e ritorno dall’<b>aeroporto di Roma Fiumicino</b> con partenza ore <b>10:30</b></>
                    },
                    {
                        value: "navettaArAeroportoFiumicino2",
                        label: <>Usufruirò del servizio navetta andata e ritorno dall’<b>aeroporto di Roma Fiumicino</b> con partenza ore <b>12:00</b></>
                    }
                ],
                params: {
                    when: [
                        ['roma', 'romaPartecipazioneConferma'], {
                            is: (roma, romaPartecipazioneConferma) => roma === 'si' && romaPartecipazioneConferma === 'si',
                            then: (schema) => schema.required("Questo campo è obbligatorio")
                        }
                    ]
                },
                conditions: {
                    type: "and",
                    predicates: [
                        {
                            id: 'roma',
                            value: 'si'
                        },
                        {
                            id: 'romaPartecipazioneConferma',
                            value: 'si'
                        }
                    ]
                },
                cols: {
                    xs: 12,
                    md: 12
                }
            },
            {
                id: "navettaRomaNote",
                name: 'navettaRomaNote',
                label: 'navettaRomaNote',
                type: 'note',
                required: false,
                validations: [],
                precompiled: false,
                cols: {
                    xs:12,
                },
                conditions: {
                    type: "and",
                    predicates: [
                        {
                            id: 'roma',
                            value: 'si'
                        },
                        {
                            id: 'romaPartecipazioneConferma',
                            value: 'si'
                        }
                    ]
                },
            }*/
        ],
        conditions: {
            type: "or",
            predicates: [
                {
                    id: 'roma',
                    value: 'si'
                }
            ]
        },
    },
    {
        id: 'partecipazioneMilano',
        name: "partecipazioneMilano",
        title: 'Milano',
        subtitle: "",
        fields: [
            {
                id: 'agendaMilano',
                name: "agendaMilano",
                type: 'agenda',
                conditions: {
                    type: "or",
                    predicates: [
                        {
                            id: 'milano',
                            value: 'si'
                        }
                    ]
                },
                cols:{
                    xs:12,
                    md:12
                }
            },
            {
                id: 'milanoPartecipazioneConferma',
                name: 'milanoPartecipazioneConferma',
                label: "confermaPartecipazione",
                type: 'radiogroup',
                validations: ["string", 'when'],
                required: false,
                precompiled: false,
                values: [
                    {
                        value: "si",
                        label: "Si"
                    },
                    {
                        value: "no",
                        label: "No"
                    }
                ],
                params: {
                    when: [
                        ['milano'], {
                            is: (milano) => milano === 'si',
                            then: (schema) => schema.required("Questo campo è obbligatorio")
                        }
                    ]
                },
                conditions: {
                    type: "or",
                    predicates: [
                        {
                            id: 'milano',
                            value: 'si'
                        }
                    ]
                },
            },
            /*{
                id: 'navettaMilanoConferma',
                name: 'navettaMilanoConferma',
                label: "navettaMilanoConferma",
                type: 'radiogroup',
                validations: ["string", 'when'],
                row: false,
                precompiled: false,
                values: [
                    {
                        value: "navettaArStazioneMilanoCentrale",
                        label: "Sì"
                    },
                    {
                        value: "no",
                        label: "No"
                    }
                ],
                params: {
                    when: [
                        ['milano', 'milanoPartecipazioneConferma'], {
                            is: (milano, milanoPartecipazioneConferma) => milano === 'si' && milanoPartecipazioneConferma === 'si',
                            then: (schema) => schema.required("Questo campo è obbligatorio")
                        }
                    ]
                },
                conditions: {
                    type: "and",
                    predicates: [
                        {
                            id: 'milano',
                            value: 'si'
                        },
                        {
                            id: 'milanoPartecipazioneConferma',
                            value: 'si'
                        }
                    ]
                },
                cols: {
                    xs: 12,
                    md: 12
                }
            },*/
        ],
        conditions: {
            type: "or",
            predicates: [
                {
                    id: 'milano',
                    value: 'si'
                }
            ]
        },
    },
    {
        id: 'privacy',
        name: "privacy",
        title: 'privacy',
        subtitle: "",
        fields: [
            {
                id: 'privacy',
                name: 'privacy',
                label: <span>Dichiaro di aver preso visione dell’informativa sul trattamento dei dati personali <a
                    style={{color: saraTheme.palette.secondary.main, fontWeight: "bold"}}
                    href={'/Informativa Roadshow Sara Ass.ni + Sara Vita 2026.pdf'} target={'_blank'}>Privacy Policy</a></span>,
                type: 'checkbox',
                validations: ['bool', "required", "oneOf"],
                required: true,
                precompiled: false,
                cols: {
                    xs: 12,
                    sm: 12
                },
                params: {
                    oneOf: [
                        [true], "Questo campo è obbligatorio"
                    ]
                }
            }
        ]
    },
]
